export class BloqueioDesbloqueioAgendaProfissionalDTO {
  constructor(
    private data: string,
    private hora: string,
    private idProfissional: number
  ) { }
}